import { render, staticRenderFns } from "./PositionEdit.vue?vue&type=template&id=2d094eb0&scoped=true&"
import script from "./PositionEdit.vue?vue&type=script&lang=js&"
export * from "./PositionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PositionEdit.vue?vue&type=style&index=0&id=2d094eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d094eb0",
  null
  
)

export default component.exports